import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  CheckInInitModel,
  CheckInInitVariables,
  CheckInModel,
  CheckInVariables,
} from '../../../../../models/email-template/check-in.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinService } from '../../../../../services/pin.service';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import { NotificationInitVariables } from '../../../../../models/template/notifications-model.interface';

@Component({
    selector: 'app-check-in',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './check-in.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './check-in.component.scss'
})
export class CheckInComponent extends BaseComponent implements OnInit {
  @Input() block: CheckInModel = new CheckInInitModel();
  @Input() isPreview = false;
  count: number = 0;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new CheckInInitVariables()
    }
  }

  //placeholders:
  headingPlaceholder: string = 'Enter Heading Text';
  textPlaceholder: string = 'Enter Text';
  imagePlaceholder: string = 'Image';
  hrefPlaceholder: string = 'Enter Image Redirect Link';
  altPlaceholder: string = 'Enter Image Alt';
  ctaLinkPlaceholder: string = 'Enter CTA Link';
  ctaTextPlaceholder: string = 'Enter CTA Text';

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof CheckInVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof CheckInVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
